<template>
    <div id="navbar">
        <transition name="bounce">
            <scrollactive
                    active-class="active"
                    class="header_area animated productive-nav"
                    itemscope="itemscope"
                    itemtype="http://schema.org/WPHeader"
                    :class="{ 'fixed': isScrolled }"
                    :offset="100"
                    :duration="800"
                    bezier-easing-value=".5,0,.35,1"
                    :clickToScroll="!clickable"
            >
                <nav class="navbar navbar-expand-lg px-lg-5 py-3" itemscope="itemscope" itemtype="http://schema.org/SiteNavigationElement">
                    <a class="navbar-brand pointer nav-logo-a scrollactive-item" itemprop="url" href="/#hero" target="_blank">
                        <img class="mx-auto img-fluid d-lg-block d-none" alt="Spiritt logo"
                             src="/img/spiritt-logo-wrapped.png">
                        <img class="mx-auto img-fluid d-lg-none" alt="Spiritt logo"
                             src="/img/saas/spiritt-white-icon.svg">
                    </a>
                    <div class="nav-item d-lg-none" v-if="this.$route.name === `Home`">
                      <a href="https://app.spiritt.io" class="btn btn-hero btn-hero-primary-mobile mr-1 mt-1">Sign In</a>
                    </div>
                    <div class="collapse navbar-collapse">
                        <ul class="navbar-nav divider-left ml-auto" id="nav">
                            <li class="nav-item px-4">
                                <a aria-label="about us" class="scrollactive-item nav-link font-weight-bold" href="/#about" target="_blank">About Us</a>
                            </li>
                            <li class="nav-item px-4">
                                <a aria-label="how it works" class="scrollactive-item nav-link font-weight-bold" href="/#how-it-works" target="_blank">How It Works</a>
                            </li>
                            <li class="nav-item px-4">
                                <a aria-label="services" class="scrollactive-item nav-link font-weight-bold" href="/#start-now" target="_blank">Start a Startup</a>
                            </li>
                            <li class="nav-item px-4">
                                <a aria-label="showcase" class="scrollactive-item nav-link font-weight-bold" href="/#why-choose-us" target="_blank">Why Us</a>
                            </li>
                            <li class="nav-item px-4">
                                <a aria-label="showcase" class="scrollactive-item nav-link font-weight-bold" href="/#showcase" target="_blank">Showcase</a>
                            </li>
                            <li class="nav-item px-4">
                                <a aria-label="pricing" class="scrollactive-item nav-link font-weight-bold" href="/#pricing" target="_blank">Pricing</a>
                            </li>
                            <li class="nav-item px-4">
                                <a aria-label="contact us" class="scrollactive-item nav-link font-weight-bold" href="/#contact" target="_blank">Contact Us</a>
                            </li>
                          <li class="nav-item px-0" v-if="this.$route.name === `Home`">
                            <a href="https://app.spiritt.io" class="btn btn-hero btn-hero-primary mr-3">Sign In</a>
                          </li>
                        </ul>
                    </div>
                </nav>
            </scrollactive>
        </transition>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'navbar',
        props: ['clickable'],
        data() {
            return {
                isNavFixed: false,
            }
        },
        computed: {
            ...mapGetters({
                isScrolled: 'layout/isScrolled',
            }),
        },
    }
</script>

<style lang="css" scoped>
.btn-hero {
  height: 48px;
  min-width: 120px;
  font-weight: bold;
  border-radius: 21px;
  cursor: pointer;
  font-size: 20px;
  margin-top: -5px;
  border: none;
}
.btn-hero-primary, .btn-hero-primary:hover, .btn-hero-primary:focus, .btn-hero-primary:active {
  color: #ffffff;
  border: 2px solid #00c092;
  padding-top: 8px;
  outline: none;
  transition: 0.3s;
}

.btn-hero-primary-mobile, .btn-hero-primary-mobile:hover, .btn-hero-primary-mobile:focus, .btn-hero-primary-mobile:active {
  color: #ffffff;
  height: 43px;
  min-width: 90px;
  border: 1px solid #00c092;
  padding-top: 9px;
  font-size: 16px;
  outline: none;
  transition: 0.3s;
}

.btn-hero-primary:hover {
  color: #00c092;
}
.btn-hero-secondary {
  color: #751da7;
  background: #fff;
}
.btn-hero-secondary:hover {
  color: #751da7;
  background: #e0e0e0;
}
    .colored circle{
        transition: all .5s ease;
    }
    .not-colored circle {
        stroke:#fff;
        transition: all .5s ease;
    }
    .colored polyline{
        transition: all .5s ease;
    }
    .not-colored polyline {
        stroke:#fff;
        transition: all .5s ease;
    }
    .colored line{
        transition: all .5s ease;
    }
    .not-colored line {
        stroke:#fff;
        transition: all .5s ease;
    }
    .slide-fade-enter-active {
        transition: all .5s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
    .navbar-nav .nav-link {
        color: #fff;
        font-size: 1rem;
    }
    .nav-logo-a {
        width: 140px;
    }
    .header_area {
        background: transparent;
        position: absolute;
        z-index: 10000;
        top: 0;
        left: 0;
        right: 0;
        height: 56px;
        transition: background 0.5s ease;
    }
    #brand-logo {
        height: 40px;
    }
    .navbar-brand {
        padding: 0;
    }
    .nav-item {
        cursor: pointer;
    }
    .active {
        font-weight: bold;
    }
    .nav-link:hover{
        color: #14d1bd;
    }
    @media (max-width: 992px) {
        .header_area {
            position: absolute;
        }
    }
    @media (max-width: 800px) {
        .nav-logo-a {
            width: 40px;
        }
    }
</style>
